import { render, staticRenderFns } from "./xinlv.vue?vue&type=template&id=e49ec040&scoped=true"
import script from "./xinlv.vue?vue&type=script&lang=ts"
export * from "./xinlv.vue?vue&type=script&lang=ts"
import style0 from "./xinlv.vue?vue&type=style&index=0&id=e49ec040&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49ec040",
  null
  
)

export default component.exports